import { createStorageSlot } from '@gonfalon/browser-storage/createStorageSlot';
import { trackRecentProjects } from '@gonfalon/dogfood-flags/dogfood-flags';

import { cacheKey } from './internal/config';
import { parseData } from './internal/parseData';
import { serializeData } from './internal/serializeData';

const slot = createStorageSlot(cacheKey, { isEnabled: trackRecentProjects() });

export function removeRecentProjectKey(key: string) {
  let removed = false;
  const data = parseData(slot.get());

  if (data.includes(key)) {
    const newData = data.filter((k) => k !== key);
    slot.set(serializeData(newData));
    removed = true;
  }

  return removed;
}
